import {Injectable} from '@angular/core';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {SessionStorageService} from 'ngx-store';

@Injectable()
export class LoginGuard implements CanActivate {

  constructor(private router: Router,
              private storage: SessionStorageService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const usuario = this.storage.get('usuario');

    if (usuario && usuario.id) {
      usuario.data_login = new Date().toString();
      this.storage.set('usuario', usuario);
      return true;
    }

    if (state.url === '/spe-acesso') {
      return true; 
    }

    this.router.navigateByUrl('/login');
    return false;
  }

}
